<template>
  <vs-popup class="sign-pad-popup" title="기사 서명" :active.sync="popupActive" style="z-index: 100000;">
    <vue-signature-pad width="256px" height="256px" ref="signaturePad" :customStyle="{border: '#999 1px solid', margin: 'auto'}" :options="{onBegin, onEnd, minWidth: 1, maxWidth: 3}" />
    <div class="mt-4 text-center">
      <vs-button color="danger" class="mr-1" @click="clearSignature">초기화</vs-button>
      <vs-button class="ml-1" @click="saveSignature">저장</vs-button>
    </div>
  </vs-popup>
</template>

<script>
import moment from 'moment'
import uniqueString from 'unique-string'
import { VueSignaturePad } from 'vue-signature-pad'

export default {
  data () {
    return {
      popupActive: false,
      audit: {}
    }
  },
  methods: {
    open (audit) {
      this.popupActive = true
      this.audit = audit
      this.$refs.signaturePad.clearSignature()
    },
    onBegin () {
      this.$refs.signaturePad.resizeCanvas()
    },
    onEnd () {
    },
    clearSignature () {
      this.$refs.signaturePad.clearSignature()
    },
    saveSignature () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (isEmpty) {
        alert('서명을 작성해주세요.')
      } else {
        this.$vs.loading()

        const storageRef = this.$storage.ref()
        const imageRef = storageRef.child(`images/${this.audit.vehicleNumber}/${moment().format('YYYY-MM-DD')}/${uniqueString()}.png`)
        imageRef.putString(data.substring(22), 'base64').then((snapshot) => {
          snapshot.ref.getDownloadURL().then((downloadURL) => {
            const data = {}
            data.signatureEngineer = downloadURL
            this.$db.collection('installations').doc(this.audit.id).update(data).then(() => {
              this.audit.signatureEngineer = downloadURL
              this.audit.__ob__.dep.notify()
              this.$vs.loading.close()
              this.popupActive = false
            })
          })
        })
      }
    }
  },
  components: {
    VueSignaturePad
  }
}
</script>

<style lang="scss">

@media screen {
  .sign-pad-popup .vs-popup {
    width: 730px !important;
  }
}

@media print {
  #app {
    display: none;
  }
  .vs-popup {
    background: none;
    box-shadow: none;
  }
  .vs-popup--header {
    display: none;
  }
  .photo-popup table td img {
    height: 227px !important;
  }
}

</style>
